/**
 * @generated SignedSource<<4f1ec9b68738a4af37583c7593b2fb6d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type groupRow_issueTableGrouping_FirstGroupRow_rankField$data = {
  readonly " $fragmentSpreads": FragmentRefs<"firstGroupIssues_issueTableGrouping">;
  readonly " $fragmentType": "groupRow_issueTableGrouping_FirstGroupRow_rankField";
};
export type groupRow_issueTableGrouping_FirstGroupRow_rankField$key = {
  readonly " $data"?: groupRow_issueTableGrouping_FirstGroupRow_rankField$data;
  readonly " $fragmentSpreads": FragmentRefs<"groupRow_issueTableGrouping_FirstGroupRow_rankField">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "groupRow_issueTableGrouping_FirstGroupRow_rankField",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "firstGroupIssues_issueTableGrouping"
    }
  ],
  "type": "JiraJqlFieldWithAliases"
};

(node as any).hash = "5602f23546a386a14074a3a5b572a140";

export default node;
